(function () {
  function parseSpecs(raw) {
    var map = {};
    if (!raw) return map;
    raw.split('||').forEach(function (line) {
      var parts = line.split('::');
      if (parts.length < 3) return;
      map[parts[0].trim()] = { format: parts[1].trim(), volume: parts[2].trim() };
    });
    return map;
  }

  function parseSkuMap(scope) {
    var map = {};
    var script = scope.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!script) return map;
    try {
      var variants = JSON.parse(script.textContent);
      variants.forEach(function (v) {
        if (v.option1) map[v.option1] = v.sku;
      });
    } catch (e) {}
    return map;
  }

  function initSpecs(root) {
    var map = parseSpecs(root.getAttribute('data-specs'));
    var formatEl = root.querySelector('[data-spec="format"]');
    var volumeEl = root.querySelector('[data-spec="volume"]');
    var skuEl = root.querySelector('[data-spec="sku"]');

    var scope = root.closest('product-info') || document;
    var skuMap = parseSkuMap(scope);

    function applyValue(value) {
      var entry = map[value];
      if (entry) {
        if (formatEl) formatEl.textContent = entry.format;
        if (volumeEl) volumeEl.textContent = entry.volume;
      }
      if (skuEl) skuEl.textContent = skuMap[value] || '';
    }

    var radios = scope.querySelectorAll('input[type="radio"]');
    var select = scope.querySelector('select.select__select');

    var checkedRadio = scope.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      applyValue(checkedRadio.value);
    } else if (select) {
      applyValue(select.value);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applyValue(radio.value);
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        applyValue(select.value);
      });
    }
  }

  document.querySelectorAll('[data-a2k-product-specs]').forEach(initSpecs);
})();
